type PrefectureOption = { value: number; label: string };

/**
 * 都道府県の表示ラベル（例: "東京都"）を API へ送るコードに変換する。
 * API/OpenAPI の契約は string だが DB の users.prefecture は integer 列なので、
 * ラベルのまま送ると Postgres が変換できず 500 になる。
 * 一致しない場合は未設定を表す空文字（defaultUserValues と同じ表現）を返す。
 */
export const toPrefectureValue = (
  label: string | undefined,
  prefectureList: PrefectureOption[]
): string => {
  const prefecture = prefectureList.find((option) => option.label === label);
  return prefecture ? `${prefecture.value}` : '';
};
